import { Injector } from '@angular/core';
import { SideViewResizeControls } from '../render/controls/side-view-resize-controls';
import { ensureKeyLocation } from '../utils/point-cloud-interpolation-helper';
import { vectorToPoint } from '../utils/point-cloud-utils';
import { addPoints } from '../utils/point-utils';
import { AbstractSideViewDragHandler } from './abstract-side-view-drag-handler';

export class SideViewTranslateCuboidDragHandler extends AbstractSideViewDragHandler {
  protected method = 'drag_side_panel_shape';

  constructor(
    initialEvent: MouseEvent,
    controls: SideViewResizeControls,
    injector: Injector,
  ) {
    super(controls, initialEvent, injector);
  }

  protected onDrag(event: MouseEvent) {
    const frameNumber = this.store.state().render.frameNumber;
    const focusedCuboidStore = this.getFocusedShapeStore();
    const locationStore = ensureKeyLocation(
      focusedCuboidStore('key_locations'),
      frameNumber,
    );
    const location = locationStore.state();

    const delta = vectorToPoint(this.getWorldDelta(event));
    const newLocation = {
      ...location,
      position: addPoints(location.position, delta),
    };

    locationStore.set(newLocation);
  }
}
